import { render, staticRenderFns } from "./ContractsEditFormSidebar.vue?vue&type=template&id=e9a2ad80&scoped=true"
import script from "./ContractsEditFormSidebar.vue?vue&type=script&lang=js"
export * from "./ContractsEditFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a2ad80",
  null
  
)

export default component.exports